import GridCardsDirectory from "./GridCardsDirectory";

export default GridCardsDirectory;
